module.exports = __webpack_public_path__ + "img/shape-8@2x.c73abc6c.png";